import React from "react";
import { Container } from "reactstrap";
import RelatedProducts from "../../RelatedProducts/RelatedProducts";
import LatestRecipes from "./LatestRecipes/LatestRecipess";
import WordpressContent from "../../../components/WordpressContent/WordpressContent";
import { useQuery } from "@apollo/react-hooks";
import { GET_SINGLE_RECIPE } from "../../../queries/recipesQuery";

import "./SingleRecipe.scss";

const SingleRecipe = (props) => {
  const slug = props.match.params.slug;

  const { data, loading, error } = useQuery(GET_SINGLE_RECIPE, {
    variables: { slug },
  });

  if (loading) return <div></div>;
  if (error) return <div>error: {error.message}</div>;

  const node = data?.posts?.edges?.[0]?.node;
  if (!node) return <div></div>;

  const relatedProductsIds = node.relatedProductsIds || [];
  const featuredImage = node.featuredImage?.node?.sourceUrl || "";
  const title = node.title || "";
  const content = node.content || "";

  return (
    <div className="SingleReceipt">
      <Container>
        <div className="columns">
          <div className="column-1">
            <p className="SingleRecipe_title">{title}</p>
            <article className="singleRecipe">
              <div className="featured-image">
                <img src={featuredImage} alt="" />
              </div>
              <WordpressContent content={content} className="WordpressContent" />
            </article>
          </div>
          <div className="column-2">
            <LatestRecipes />
          </div>
        </div>

        {relatedProductsIds.length >= 1 && (
          <div className="RelatedProducts-Container">
            <h5 className="relatedProducts_title">
              Produkte që ju nevojiten për këtë recetë
            </h5>
            <RelatedProducts
              singleRecipe={true}
              limit={8}
              relatedProductsIds={relatedProductsIds}
            />
          </div>
        )}
      </Container>
    </div>
  );
};

export default SingleRecipe;
